import { render, staticRenderFns } from "./ItemIndicators.vue?vue&type=template&id=c4b6465c&scoped=true"
import script from "./ItemIndicators.vue?vue&type=script&lang=ts"
export * from "./ItemIndicators.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b6465c",
  null
  
)

export default component.exports